import clsx from 'clsx';

import type { FCCCN } from '../../../../types';

export const FormPage: FCCCN = ({ children, className }) => {
    return <div className={clsx('flex w-full flex-col space-y-7 p-1', className)}>{children}</div>;
};